import { customElement } from 'lit/decorators.js';
import { css, html, LitElement } from 'lit';

@customElement('gz-animated-highlight-box')
export class GzAnimatedHighlightBoxWebComponent extends LitElement {
  static get styles() {
    return css`
      :host {
        position: fixed;
        display: flex;
        pointer-events: none; /* Let clicks pass through */
      }

      .box {
        padding: var(--spacer);
        position: relative;
        overflow: hidden;
        width: 100%;
        max-width: 100%;
        border-radius: 8px;
        border: 5px solid var(--blue-layout-403-primary);
      }
    `;
  }

  render() {
    return html`<div class="box"></div> `;
  }

  public updatePosition(top: number, left: number, width: number, height: number): void {
    this.style.top = `${top}px`;
    this.style.left = `${left}px`;
    this.style.width = `${width}px`;
    this.style.height = `${height}px`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-animated-highlight-box': GzAnimatedHighlightBoxWebComponent;
  }
}
